module.exports = __webpack_public_path__ + "img/C03TechReinforcedHull_ua.e415ac56.webp";